import AccountTreeIcon from '@mui/icons-material/AccountTree';
import {
  Box,
  Button,
  IconButton,
  Tooltip,
  Typography,
  useTheme,
} from '@mui/material';
import { tokens } from '../../global/theme/tokens';
import { API_PATCH, DBRequest, useConfig } from '../../api/api';
import ExoDialog from '../exo/ExoDialog';
import { SelectSalesObject } from '../select/SelectSalesObject';
import { useState } from 'react';
import Loader from '../special/Loader';
import { NavLink } from 'react-router-dom';
import DeleteIcon from '@mui/icons-material/Delete';
import { SelectProject } from '../form/form-fields/TypeProject';

export const ECLinkProject = ({ onChange, email }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode, theme.palette.colorTheme);
  const config = useConfig();

  const [open, setOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const { project } = email;

  function updateEmail(project) {
    const reqData = { project };
    setOpen(false);
    DBRequest({
      config,
      path: `imap-emails/${email.id}`,
      method: API_PATCH(reqData),
      onResponse: (res) =>
        onChange({
          ...res,
          data: { ...res.data, projectId: res.data.project?.id },
        }),
      onLoading: setIsLoading,
    });
  }
  const { nr, name, image, id } = project || {};

  return (
    <>
      <Loader active={isLoading} />
      {project ? (
        <Box
          className="flex gap-2 items-center"
          sx={{
            '.del-button': {
              opacity: 0,
              transition: '0.3s ease',
              transform: 'scale(0)',
            },
            ':hover': {
              '.del-button': {
                opacity: 1,
                transform: 'scale(1)',
              },
            },
          }}
        >
          <Button
            sx={{ padding: 0, minWidth: 'unset' }}
            onClick={() => setOpen(true)}
          >
            {image ? (
              <img
                className="w-[60px] h-[30px] rounded-md object-cover"
                src={image.thumbnailUrl || image.temporaryUrl}
              />
            ) : (
              <Box
                sx={{ bgcolor: colors.bgInput }}
                className="w-[60px] h-[30px] rounded-md flex items-center justify-center"
              >
                <AccountTreeIcon sx={{ fontSize: 16 }} />
              </Box>
            )}
          </Button>
          <Box className="flex flex-col h-full items-center">
            <NavLink to={`/projects/management/${id}`}>
              <Typography fontWeight={500} className="opacity-60">
                {`${nr} - ${name}`}
              </Typography>
            </NavLink>
          </Box>
          <IconButton
            className="del-button"
            color="error"
            onClick={() => updateEmail(null)}
          >
            <DeleteIcon sx={{ fontSize: '16px' }} />
          </IconButton>
        </Box>
      ) : (
        <Tooltip>
          <Button
            onClick={() => setOpen(true)}
            sx={{
              minWidth: 0,
              padding: '6px',
              border: `1px solid ${colors.info}80`,
              ':hover': {
                bgcolor: colors.info + '30',
              },
            }}
          >
            <AccountTreeIcon />
          </Button>
        </Tooltip>
      )}

      <ExoDialog open={open} onClose={() => setOpen(false)}>
        <SelectProject selected={email.project} onSelect={updateEmail} />
      </ExoDialog>
    </>
  );
};
